import { consola } from 'consola'
import type {
  AdminLoginDto,
  AdminAuthResponse,
  AdminLogoutResponse,
  AdminMeResponse,
} from '../model/types'
import { useApi } from '@/shared/api'

const logger = consola.withTag('api-admin-auth')

/**
 * API-клиент авторизации администратора.
 * Базовый URL: /api/v2/admin/auth
 */
class APIAdminAuth {
  async login(data: AdminLoginDto): Promise<AdminAuthResponse> {
    logger.info('Admin login')
    const response = await useApi(true, true).post<AdminAuthResponse>('/admin/auth/login', { body: data })
    logger.success('Admin authenticated')
    return response.data
  }

  async refresh(refreshToken: string): Promise<{ adminAccessToken: string; adminRefreshToken: string }> {
    logger.info('Refreshing admin tokens')
    const response = await useApi(true, true).post<{ adminAccessToken: string; adminRefreshToken: string }>(
      '/admin/auth/refresh',
      { body: { adminRefreshToken: refreshToken } },
    )
    logger.success('Admin tokens refreshed')
    return response.data
  }

  async logout(): Promise<AdminLogoutResponse> {
    logger.info('Admin logout')
    const response = await useApi(true, true).post<AdminLogoutResponse>('/admin/auth/logout')
    logger.success('Admin logged out')
    return response.data
  }

  /** @deprecated Используйте данные из ответа login */
  async getMe(): Promise<AdminMeResponse> {
    const response = await useApi(true, true).get<AdminMeResponse>('/admin/me')
    return response.data
  }
}

export const apiAdminAuth = new APIAdminAuth()
export default apiAdminAuth
